// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"b9-z"};